/** Últimos N dias antes do vencimento: aviso no topo do painel e na tela de licença. */
export const LICENSE_EXPIRING_SOON_MAX_DAYS = 7;

export function isLicenseInactive(dias: number | null | undefined): boolean {
  return dias !== null && dias !== undefined && dias === 0;
}

/** Entre 1 e LICENSE_EXPIRING_SOON_MAX_DAYS (inclusive). */
export function isLicenseExpiringSoon(dias: number | null | undefined): boolean {
  if (dias === null || dias === undefined) return false;
  return dias >= 1 && dias <= LICENSE_EXPIRING_SOON_MAX_DAYS;
}

export const LICENSE_DIAS_CACHE_KEY = "license_dias_summary";
export const LICENSE_DIAS_CACHE_TTL_MS = 15 * 60 * 1000;

export type LicenseDiasCache = {
  cnpj: string;
  diasRestantes: number;
  ts: number;
};

export function readLicenseDiasCache(cnpj: string): LicenseDiasCache | null {
  const clean = (cnpj || "").replace(/\D/g, "");
  if (!clean) return null;
  try {
    const raw = localStorage.getItem(LICENSE_DIAS_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as LicenseDiasCache;
    if (
      (parsed?.cnpj || "").replace(/\D/g, "") !== clean ||
      typeof parsed?.diasRestantes !== "number" ||
      typeof parsed?.ts !== "number"
    ) {
      return null;
    }
    if (Date.now() - parsed.ts > LICENSE_DIAS_CACHE_TTL_MS) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function writeLicenseDiasCache(cnpj: string, diasRestantes: number): void {
  const clean = (cnpj || "").replace(/\D/g, "");
  if (!clean) return;
  try {
    const payload: LicenseDiasCache = {
      cnpj: clean,
      diasRestantes,
      ts: Date.now(),
    };
    localStorage.setItem(LICENSE_DIAS_CACHE_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function clearLicenseDiasCache(): void {
  try {
    localStorage.removeItem(LICENSE_DIAS_CACHE_KEY);
  } catch {
    /* ignore */
  }
}
